import { render } from "./addNewGarmentModelModal.vue?vue&type=template&id=6b65d820&ts=true"
import script from "./addNewGarmentModelModal.vue?vue&type=script&lang=ts"
export * from "./addNewGarmentModelModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__